import React, { memo, useEffect, useMemo, useState, useCallback } from 'react';
import { Link } from '@Sage/hoi-poi-ui';
import CopilotTable from '../../Table';
import CopilotChart from '../../Chart';

const validLinkAttributes = ['id'];

const CustomLink = ({ title, loading, tables, reports, ...props }) => {
    const [parsedData, setParsedData] = useState({ title: undefined, attributes: {} });

    const { href, ...otherProps } = props;

    const parseTitleString = useCallback((str) => {
        try {
            const parsedJson = JSON.parse(str);
            const finalAttributes = Object.entries(parsedJson).reduce((acc, [key, value]) => {
                if (validLinkAttributes.includes(key)) {
                    acc[key] = value;
                }
                return acc;
            }, {});
            setParsedData({ title: undefined, attributes: finalAttributes });
        } catch (error) {
            setParsedData({ title: str, attributes: {} });
        }
    }, []);

    const { Component, finalProps } = useMemo(() => {
        const { attributes, title: finalTitle } = parsedData;

        if (href?.includes('fm_table')) {
            return {
                Component: CopilotTable,
                finalProps: { id: attributes.id, loading, data: (tables || {})[attributes.id] || [] },
            };
        }

        if (href?.includes('fm_report')) {
            return {
                Component: CopilotChart,
                finalProps: { id: attributes.id, loading, ...((reports || {})[attributes.id] || {}) },
            };
        }

        const { id, ...otherAttrs } = attributes;

        return {
            Component: Link,
            finalProps: {
                target: '_blank',
                title: finalTitle,
                variation: 'primary',
                ...otherAttrs,
                href,
                ...otherProps,
            },
        };
    }, [parsedData, href, otherProps, loading, tables, reports]);

    useEffect(() => {
        if (title) {
            parseTitleString(title);
        }
    }, [title, parseTitleString]);

    return <Component {...finalProps} />;
};

export default memo(CustomLink);
